




















import moment from 'moment';
import { Component, Prop, Vue } from 'vue-property-decorator';
import Clue from '@/components/Clue.vue';

interface IClue {
  start: Date
  title: string
  message: string
  image?: string
}

@Component({
  components: {
    Clue
  }
})
export default class ScavengerHunt extends Vue {
  private now: Date = new Date();
  private clues: IClue[] = [
    {
      start: new Date(2019, 4, 10, 0, 0, 0),
      title: 'De spanning stijgt',
      message: 'In spanning bereiden de ouders van Simon en Marjolein zich voor op het onbekende dat zich zal geschieden op 11 mei 2019, oftewel Moeder- en Vaderdag. Nieuwe clues zullen vanzelf verschijnen als de tijd rijp is! De eerste zelfs al om 11:15 uur. Zorg voor goede wandelschoenen en een lege maag! Er zal namelijk genoeg gelopen en gegeten worden vandaag!'
    },
    {
      start: new Date(2019, 4, 11, 11, 15, 0),
      image: 'station',
      title: 'Het Begin!',
      message: 'De dag is nu echt begonnen. Jullie zijn hier nog wel even. En daarom krijgen jullie hierbij de eerste clue! Zorg dat je om 12:15 uur op station Bodegraven bent om de trein richting de stad te pakken waar jullie zoon woont. Je zou toch zeggen dat deze opdracht nog wel zou moet lukken?'
    },
    {
      start: new Date(2019, 4, 11, 12, 15, 0),
      image: 'trein',
      title: 'Chooo Chooo!',
      message: 'Op naar Leiden.. ohnee, Utrecht! En daar komt de conducteur, en die knipt...'
    },
    {
      start: new Date(2019, 4, 11, 12, 20, 0),
      title: 'Mind the gap between the train and the platform',
      message: 'Stap zometeen uit bij Utrecht Centraal.'
    },
    {
      start: new Date(2019, 4, 11, 12, 32, 0),
      image: 'bus',
      title: 'Busje komt zo',
      message: 'Zoek bus 28 richting de Uithof, en stap in de bus. Vergeet niet uit te checken bij de NS en in te checken in de bus, maar dat zal wel goedkomen als het omroepsysteem en de buschauffeur jullie hier aan helpen herinneren. Waar jullie uit moeten stappen is nog even een geheim ...'
    },
    {
      start: new Date(2019, 4, 11, 12, 50, 0),
      image: 'bloem',
      title: 'Botanische Tuinen',
      message: 'Uitstaphalte: Botanische Tuinen op de Uithof. Hebben jullie al een vermoeden waar jullie naar toe gaan? Heel goed! Jullie zijn nu op het begin van jullie route door weer en wind, die jullie zal leiden langs mooie bezienswaardigheden en heerlijk eten. En hopelijk voegt jullie zoon zich zo bij jullie. En hoe kunnen we deze dag mooier beginnen dan met heerlijke wandeling door de botanische tuinen. Geniet van de bloemen, en geniet van de natuur.'
    },
    {
      start: new Date(2019, 4, 11, 13, 15, 0),
      image: 'cadeau',
      title: 'Cadeauronde 1',
      message: 'En dan nu het moment waarop jullie hebben gewacht. We hopen dat dit cadeau jullie ouderschap verzacht. Maar ga niet op nog meer cadeaus hopen, want we wilden verder niks anders kopen.'
    },
    {
      start: new Date(2019, 4, 11, 14, 30, 0),
      title: 'Aanstalte maken',
      message: 'Zorg dat jullie over 15 minuten weer bij de uitgang zijn!'
    },
    {
      start: new Date(2019, 4, 11, 14, 45, 0),
      image: 'route1_half',
      title: 'Start Route #01',
      message: 'En dan is het nu tijd om de Botanische Tuinen achter ons te laten en ons ter voet te verplaatsen richting ... Ja waar naartoe eigenlijk? Kijk op het kaartje voor de eerste helft van de route. Volg deze route goed, want over 10 minuten ontvangen jullie de tweede helft van de route en jullie willen natuurlijk niet te laat komen bij de bestemming!'
    },
    {
      start: new Date(2019, 4, 11, 14, 50, 0),
      title: 'Oude huis van Lisa',
      message: 'Als het goed is lopen jullie zo langs een plek waar Lisa een tijdje gewoont heeft samen met Anouk. Herkennen jullie het nog?'
    },
    {
      start: new Date(2019, 4, 11, 14, 55, 0),
      image: 'route1',
      title: 'Route #01',
      message: 'Zoals beloofd, precies 10 minuten later, de rest van de route! Kun je nu al zien waar jullie naar toe gaan?'
    },
    {
      start: new Date(2019, 4, 11, 15, 5, 0),
      title: 'Rietveld Schröderhuis',
      message: 'Jullie lopen zo langs het Rietveld Schröderhuis. Dit huis is een door Gerrit Rietveld in 1923-1924 ontworpen woonhuis in de stad Utrecht. Het huis is volledig uitgevoerd volgens de ideeën van de kunstbeweging De Stijl. Rietveld ontwierp het huis voor Truus Schröder-Schräder, die er van januari 1925 tot haar dood in 1985 heeft gewoond. Het staat sinds 2000 op de Werelderfgoedlijst van de UNESCO. Helaas gaan we niet naar binnen maar bewonderen we het huis even van de buitenkant'
    },
    {
      start: new Date(2019, 4, 11, 15, 10, 0),
      image: 'ijsje',
      title: 'IJS!',
      message: 'Een strikvraag: Is het nu tijd voor een ijsje of voor een biertje? ... Allebei natuurlijk! Tijd voor een wel verdiend ijsje en ook voor een heerlijk biertje met uitzicht op het Wilhelmina park bij Parkcafe Buiten.'
    },
    {
      start: new Date(2019, 4, 11, 15, 25, 0),
      image: 'cadeau',
      title: 'Cadeauronde 2',
      message: 'Is de paashaas te laat of sinterklaas misschien hier op vakantie? Want kijk eens wat je hier in Simons hand ziet! Het is niet waar, maar je ziet het echt! Nog een cadeau, deze is zeker niet slecht.'
    },
    {
      start: new Date(2019, 4, 11, 16, 0, 0),
      image: 'route2_half',
      title: 'Start Route #02',
      message: 'Na dit heerlijke ijsje en/of biertje is het tijd om de wandeling weer voort te zetten. Volg de route op de onderstaande kaart. Hopelijk lopen jullie nog wel recht genoeg (na al dat bier) om op tijd bij de eindbestemming aan te komen. Om het even overzichtelijk te houden is dit wederom alleen het eerste gedeelte van de route, de rest volgt zodra jullie er klaar voor zijn.'
    },
    {
      start: new Date(2019, 4, 11, 16, 5, 0),
      title: 'Wilhelminapark',
      message: 'Jullie lopen nu door of langs het Wilhelminapark. Dit park is een rijksmonumentaal stadspark in de Nederlandse stad Utrecht. Centraal in het Wilhelminapark ligt een grote vijverpartij. Het park wordt doorsneden door een fietspad, dat druk gebruikt wordt door studenten die tussen De Uithof en de binnenstad fietsen. Het standbeeld van koningin Wilhelmina staat langs dit pad en is een van de meerdere kunstwerken in het park.'
    },
    {
      start: new Date(2019, 4, 11, 16, 9, 0),
      title: 'De Rode Beuk',
      message: 'Hebben jullie de prachtige rode beuk gezien? In 2014 werd er een schimmel ontdekt in de boom. Sindsdien zijn er zorgen om de beuk, maar er is geen kans dat de boom omvalt. De beuk heeft wel enkele zware takken die zijn afgestorven. De boom wordt nu iedere maand gecheckt op de gezondheid. '
    },
    {
      start: new Date(2019, 4, 11, 16, 10, 0),
      image: 'route2',
      title: 'Route #02',
      message: 'Hebben jullie een weg uit het Wilhelminapark kunnen vinden? Zijn jullie er al bijna? Ik heb dorst! Ik ga dooooood... Volg maar snel de rest van de route voor het uit de hand gaat lopen.'
    },
    {
      start: new Date(2019, 4, 11, 16, 15, 0),
      title: 'Bestemmingshint',
      message: 'Even een rekensom om scherp te blijven. De plek waar we naartoe gaan heeft te maken met dit getal: (4*4+6*3)+(546-492)=... Jullie mogen geen rekenmachine gebruiken!'
    },
    {
      start: new Date(2019, 4, 11, 16, 20, 0),
      title: 'Nog ouder huis van Lisa',
      message: 'Zien jullie in de verte ook weer een huis waar Lisa heeft gewoond?'
    },
    {
      start: new Date(2019, 4, 11, 16, 25, 0),
      image: 'loft88',
      title: 'Loft88',
      message: 'Eindelijk, we zijn er. Hadden jullie de rekensom goed? Tijd voor een voorgerecht. Loft88 is een prachtige plek om een klein hapje te eten, eet niet te langzaam (of bestel gewoon niet te veel), want voor je het weet krijg je al weer een hint om door te lopen!'
    },
    {
      start: new Date(2019, 4, 11, 17, 10, 0),
      image: 'cadeau',
      title: 'Cadeauronde 3',
      message: 'Tot nu was deze dag een present. Maar het is nog niet over, lieve vrouw en vent! In de tas van Marjolein zit toch nog een cadeautje verstopt. Sorry dat we jullie eerder hebben gefopt!'
    },
    {
      start: new Date(2019, 4, 11, 17, 30, 0),
      image: 'route3_half',
      title: 'Route #03',
      message: 'Het is helaas tijd om Loft(4*4+6*3)+(546-492) te verlaten. We vervolgen daarom onze route. Volg de route op onderstaande kaart en over 10 minuten ontvangen jullie de tweede helft van de route!'
    },
    {
      start: new Date(2019, 4, 11, 17, 40, 0),
      image: 'route3',
      title: 'Route #03',
      message: 'Zijn jullie verdwaald geraakt? Niet getreurd: hier moet je naar toe!'
    },
    {
      start: new Date(2019, 4, 11, 17, 55, 0),
      image: 'grieksrestauranteuropa',
      title: 'Europa!',
      message: 'Dat we in Europa zijn wisten we natuurlijk al, en Griekenland ligt ook in europa. Wat een toeval! Hebben jullie dan toevallig ook nog zin in grieks eten? Zo ja: gelukkig, want we zijn bij een grieks restaurant! Zo nee: laat je verbazen over hoe lekker het griekse eten is, zelfs als je er geen zin in hebt! Treuzel niet te lang over het te eten gerecht, want voor je het weet krijg je al weer een hint om door te lopen! Eet smakelijk!'
    },
    {
      start: new Date(2019, 4, 11, 18, 45, 0),
      image: 'cadeau',
      title: 'Cadeauronde 4',
      message: 'Oké, voor de allerlaatste keer. Nee, nu is het niet leuk meer. Een cadeau met onze ziel en zaligheid. Van jullie lieve jongen en lieve meid.'
    },
    {
      start: new Date(2019, 4, 11, 19, 15, 0),
      image: 'route4_half',
      title: 'Route #04',
      message: 'En daar gaan we weer. Hebben we er nog zin in? Kunnen de voeten nog? Of moet er een afsnijroute worden genomen? Volg de route op onderstaande kaart en zie zelf hoe snel je op de bestemming aankomst als je gewoon snel doorloopt!'
    },
    {
      start: new Date(2019, 4, 11, 19, 20, 0),
      title: 'Griftpark',
      message: 'Welkom in het Griftpark! Door het park loopt het stroompje de Biltsche Grift waar het park zijn naam aan dankt. Maar let op: niet te lang bij de skatebaan, voetbalkooi of aan de rand van het meer blijven hangen hea!! Het terrein hier is namelijk sterk verontreinigd geraakt door de fabrieken die hier vroeger stonden. Het park kreeg daarom in Utrecht de toepasselijke bijnaam Gifpark. De verontreinigde grond is nu als het ware ingepakt waardoor het gif geen schade meer kan aanrichten.'
    },
    {
      start: new Date(2019, 4, 11, 19, 30, 0),
      image: 'route4',
      title: 'Route #04',
      message: 'Welke kant lopen jullie nou op? Ik zei net toch dat jullie een afsnijroute moesten nemen...! Jullie zijn helemaal omgelopen, nouja hopelijk was het Griftpark het wel waard.'
    },
    {
      start: new Date(2019, 4, 11, 19, 33, 0),
      title: 'Stadsbuitengracht',
      message: 'Loop dan ook nog maar een stukje langs de Stadsbuitengracht, dit is de singel rond de oude binnenstad van Utrecht. De Stadsbuitengracht is aangelegd in de twaalfde eeuw als verdedigingswerk van de stad. Zou jij er overheen kunnen springen?'
    },
    {
      start: new Date(2019, 4, 11, 19, 55, 0),
      image: 'ellisburgers',
      title: '3 Burgers, 2 Studenten',
      message: 'Op ouderdag kan je natuurlijk niet afsluiten zonder het eten van een overheerlijke burger. Past het er nog bij in je maag? Tip: Jullie kunnen indien nodig natuurlijk ook delen!'
    },
    {
      start: new Date(2019, 4, 11, 21, 0, 0),
      image: 'vol',
      title: 'Voller dan Vol',
      message: 'Na al het eten van vandaag kan er niks meer bij, tijd voor de laatste wandeling. Loop nu richting de oude gracht.. Na een paar minuten wandelen is het al weer tijd voor de volgende tip'
    },
    {
      start: new Date(2019, 4, 11, 21, 3, 0),
      image: 'ijsje',
      title: 'Venetia',
      message: 'Willen jullie toch nog een ijsje? Dan is dit het moment! Zo niet? Loop dan door richting Tivoli. Ik zou gewoon voor dat ijsje gaan: wat dacht je van 3 bolletjes p.p.?'
    },
    {
      start: new Date(2019, 4, 11, 21, 10, 0),
      image: 'afscheid',
      title: 'Zwaai Zwaai',
      message: 'De dag is al weer voorbij. Op naar huis! Of is er toch nog genoeg tijd voor een biertje bij het gegeven paard? Onafhankelijk van de overige keuzes die jullie deze avond nog maken zit de speurtocht/tapastocht erop. En daarmee is er ook een einde gekomen aan Moeder- en Vaderdag 2019. Hopelijk hebben jullie een hele leuke dag gehad! Liefs, Simon en Marjolein'
    },
  ];
  private debug: boolean = false;
  private debugStartTime: Date = new Date();

  mounted() {
    this.tick();
  }

  get visibleClues(): IClue[] {
    return this.clues
      .filter(clue => clue.start <= this.now)
      .sort((a, b) => moment(b.start).diff(moment(a.start)));
  }

  get nowDisplayable() {
    return moment(this.now).format('YYYY-MM-DD HH:mm:ss');
  }

  tick() {
    if (this.debug) {
      const timeOnPage = moment().diff(this.debugStartTime);
      this.now = moment(new Date(2019, 4, 11, 10, 0, 0)).add(timeOnPage * 2, "seconds").toDate();
    } else {
      this.now = new Date();
    }
    requestAnimationFrame(this.tick);
  }
}
